"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordForm = ResetPasswordForm;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
// field components
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const react_router_1 = require("react-router");
function ResetPasswordForm() {
    const intl = (0, react_intl_1.useIntl)();
    const [form] = antd_1.Form.useForm();
    const history = (0, react_router_1.useHistory)();
    const [loading, setLoading] = react_1.default.useState(false);
    const onFinish = async (values) => {
        try {
            setLoading(true);
            // @ts-ignore
            const { token } = history.getQuery();
            const resetPasswordResponse = await Api.Account.resetPassword(token, values.password);
            if (resetPasswordResponse.status === 200) {
                const redirectPath = resetPasswordResponse.type === 1 ? '/admin' : '/ucet';
                // @ts-ignore
                history.pushLocalized(redirectPath);
            }
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'global.notification_variants.error',
                }),
                description: intl.formatMessage({
                    id: 'global.notification_variants.something_went_wrong',
                }),
            });
        }
        finally {
            setLoading(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(antd_1.Form, { form: form, layout: "vertical", onFinish: onFinish, children: [(0, jsx_runtime_1.jsx)("div", { className: "form__row", children: (0, jsx_runtime_1.jsxs)(antd_1.Row, { gutter: [16, 0], children: [(0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                                    id: 'reset_password.reset_password.password',
                                }), name: "password", rules: [
                                    {
                                        required: true,
                                        message: intl.formatMessage({
                                            id: 'registration.sync_validation.password',
                                        }),
                                    },
                                    {
                                        min: 8,
                                        message: intl.formatMessage({
                                            id: 'registration.sync_validation.restricted_length_password',
                                        }),
                                    },
                                    {
                                        pattern: /^.*(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/g,
                                        message: intl.formatMessage({
                                            id: 'registration.sync_validation.restricted_symbols_password',
                                        }),
                                    },
                                ], validateTrigger: "onBlur", children: (0, jsx_runtime_1.jsx)(antd_1.Input.Password, {}) }) }), (0, jsx_runtime_1.jsx)(antd_1.Col, { xs: { span: 24 }, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { label: intl.formatMessage({
                                    id: 'reset_password.reset_password.passwordRepeat',
                                }), name: "passwordRepeat", rules: [
                                    {
                                        required: true,
                                        message: intl.formatMessage({
                                            id: 'registration.sync_validation.fill_repeate_password_field',
                                        }),
                                    },
                                    ({ getFieldValue }) => ({
                                        validator(_, value) {
                                            if (value && getFieldValue('password') === value) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error(intl.formatMessage({
                                                id: 'registration.sync_validation.passwordRepeat',
                                            })));
                                        },
                                    }),
                                ], validateTrigger: "onBlur", children: (0, jsx_runtime_1.jsx)(antd_1.Input.Password, {}) }) })] }) }), (0, jsx_runtime_1.jsx)("div", { className: "form__submit", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { htmlType: "submit", color: "brand", loading: loading, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "reset_password.reset_password.password_recovery" }) }) })] }));
}
